import { render, staticRenderFns } from "./CreatePopupVendor.vue?vue&type=template&id=182d9171&scoped=true&"
import script from "./CreatePopupVendor.vue?vue&type=script&lang=js&"
export * from "./CreatePopupVendor.vue?vue&type=script&lang=js&"
import style0 from "./CreatePopupVendor.vue?vue&type=style&index=0&id=182d9171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d9171",
  null
  
)

export default component.exports